<template lang="pug">
  .columns
    .column.is-3
      .control.is-bottom
        .tags.has-addons
          span.tag.is-medium
            | Cantidad Entregada
          span.tag.is-black.is-medium 
            | {{ consumible.cantidad_r }}
    .column.is-1
      b Reingreso
    .column.is-2
      .field
        .control
          input.input.is-primary(
            type='number', 
            v-model="cantidadIn",
            :disabled="isDisabled"
            min="1"
          )
    .column.is-2
      a.button.is-black.is-rounded.is-bottom(@click="saveConsumible")
        | Guardar
</template>

<script>
  export default {
    name: 'FormItem_Cons_Reingreso',
    props: {
      consumible: {
        type: Object,
        default: () => {}
      },
    },
    data() {
      return {
        isDisabled: false,
        cantidadIn: 1
      }
    },
    methods: {
      saveConsumible() {
        let myObj = {
          cantidad: this.consumible.cantidad_r,
          cantidadIn: parseInt(this.cantidadIn),
          descripcion: this.consumible.descripcion,
          fechaReg: this.consumible.fechaReg,
          id: this.consumible.id,
          idSalida: this.consumible.idSalida,
          idconsumible: this.consumible.idconsumible,
          oficina: this.consumible.oficina,
          text: this.consumible.text,
          ubicacion: this.consumible.ubicacion,
        }
        this.$emit('addCons_Reingreso', myObj)
      }
    },
  }
</script>

<style lang="scss" scoped>

</style>


// WEBPACK FOOTER //
// src/components/inventario_Componentes/FormItem_Cons_Reingreso.vue